import { render, staticRenderFns } from "./ui-empty.vue?vue&type=template&id=6ff435f6"
import script from "./ui-empty.vue?vue&type=script&lang=js"
export * from "./ui-empty.vue?vue&type=script&lang=js"
import style0 from "./ui-empty.vue?vue&type=style&index=0&id=6ff435f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports